import _ from 'lodash';
import { useRef, useMemo, useLayoutEffect } from 'react';

/**
 * Very rude hack. But it works. At least now. It makes dialog hide animation
 * possible without extra JS code in place. When dialog is hiding it shows
 * an HTML clone of what was the dialog's content until animation is finished.
 */
export default function useDialogHide(isOpen: boolean, delay: number) {
  const rootRef = useRef<HTMLDivElement | null>(null);
  const bodyRef = useRef<HTMLDivElement | null>(null);
  const cloneRef = useRef<HTMLDivElement | null>(null);

  const bodyHTML: string | null = useMemo(() => {
    return isOpen || !bodyRef.current
      ? null
      : // preserve dialog-body html before it would be unmounted
        bodyRef.current.outerHTML;
  }, [isOpen]);

  useLayoutEffect(() => {
    if (isOpen || !bodyHTML || !rootRef.current) {
      // in case of spam of isOpen changes
      cloneRef.current?.remove();
      return;
    }

    // place a dead copy of dialog-body html where it's supposed to be
    rootRef.current.insertAdjacentHTML('beforeend', bodyHTML);
    cloneRef.current = orDie(
      _.last(rootRef.current.children)
    ) as HTMLDivElement;

    // to enable hide animation set it's data-open to false
    cloneRef.current.setAttribute('data-open', 'false');

    // remove this hack right after animation is finished
    const timeout = setTimeout(() => cloneRef.current?.remove(), delay);
    return () => {
      clearTimeout(timeout);
    };
  }, [isOpen]);

  return { rootRef, bodyRef };
}
